import { SwipeableDrawerProps } from "@mui/material"

import { undefinedFunctionWarning } from "@l2r-front/l2r-utils"

import * as Styled from "./BottomSheet.styled"

type BottomSheetProps = SwipeableDrawerProps & {
    displayPuller?: boolean,
}

export const BottomSheet = (props: BottomSheetProps) => {

    const {
        className,
        children,
        displayPuller = false,
        id = "bottom-sheet",
        ModalProps,
        onOpen = undefinedFunctionWarning("onOpen"),
        ...bottomSheetProps
    } = props

    return <Styled.SwipeableDrawer
        anchor="bottom"
        className={className}
        ModalProps={{
            ...ModalProps,
            keepMounted: true,
        }}
        onOpen={onOpen}
        {...bottomSheetProps}
    >
        <Styled.Box id={id}>
            {displayPuller && <Styled.PullerContainer id="puller-container">
                <Styled.Puller />
            </Styled.PullerContainer>}
            {children}
        </Styled.Box>
    </Styled.SwipeableDrawer>
}